const startCreatePrivatBankSetting = (state) => {
  state.isSendFormCompanyBankAccountSettings = true
  state.error = null
}

const finishCreatePrivatBankSettingSuccess = (state, companyBankAccountSetting) => {
  const newCompanyBankAccountSetting = Object.assign({}, companyBankAccountSetting)
  state.isSendFormCompanyBankAccountSettings = false
  state.privatBankState = newCompanyBankAccountSetting
  state.error = null
}

const finishCreatePrivatBankSettingError = (state) => {
  state.isSendFormCompanyBankAccountSettings = false
}

const startCreateAvalBankSetting = (state) => {
  state.isSendFormCompanyBankAccountSettings = true
  state.error = null
}

const finishCreateAvalBankSettingSuccess = (state, companyBankAccountSetting) => {
  const newCompanyBankAccountSetting = Object.assign({}, companyBankAccountSetting)
  state.isSendFormCompanyBankAccountSettings = false
  state.avBankState = newCompanyBankAccountSetting
  state.error = null
}

const finishCreateAvalBankSettingError = (state) => {
  state.isSendFormCompanyBankAccountSettings = false
}

const startDeleteBankSetting = (state) => {
  state.isSendFormCompanyBankAccountSettings = true
}

const finishDeleteBankSettingSuccess = (state) => {
  state.isSendFormCompanyBankAccountSettings = false
}

const finishDeletePrivatBankSettingError = (state) => {
  state.isSendFormCompanyBankAccountSettings = false
}

const fetchSettingsAccountsByCompanyOkpo = (state) => {
  state.isLoading = true
  state.error = null
  state.companyBankAccountsSetting = []
}

const fetchSettingsAccountsByCompanyOkpoSuccess = (state, companyBankAccountsSettings) => {
  state.isLoading = false
  state.error = null
  state.companyBankAccountsSettings = companyBankAccountsSettings
}

const fetchSettingsAccountsByCompanyOkpoError = (state, error) => {
  state.isLoading = false
  state.error = error
  state.companyBankAccountsSettings = []
}

export default {
  fetchSettingsAccountsByCompanyOkpo,
  fetchSettingsAccountsByCompanyOkpoError,
  fetchSettingsAccountsByCompanyOkpoSuccess,
  startCreatePrivatBankSetting,
  finishCreatePrivatBankSettingSuccess,
  finishCreatePrivatBankSettingError,
  startDeleteBankSetting,
  finishDeleteBankSettingSuccess,
  finishDeletePrivatBankSettingError,
  startCreateAvalBankSetting,
  finishCreateAvalBankSettingError,
  finishCreateAvalBankSettingSuccess,
}
